import React, { useMemo } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import EventDetailsDefinitionList from "components/events/events/EventDetailsDefinitionList";
import { eventTypeAttribute } from "components/events/events/ColumnRenderers";
import useEventsAdditionalData from "components/events/ReplaySearchSidebar/hooks/useEventsAdditionalData";
import useEventById from "hooks/useEventById";
import { Spinner } from "components/common";
import ExpandableSection from "components/events/ReplaySearchSidebar/ExpandableSection";
import EventDefinitionInfoList from "components/event-definitions/replay-search/EventDefinitionInfoList";
import ReplaySearchContext from "components/event-definitions/replay-search/ReplaySearchContext";
const useAttributesList = () => {
  const { t } = useTranslation("events");
  return useMemo(
    () => [
      {
        id: "timestamp",
        title: t("alerts_attributes.timestamp"),
        type: "DATE"
      },
      {
        id: "alert",
        title: t("alerts_attributes.type")
      },
      {
        id: "message",
        type: "STRING",
        title: t("alerts_attributes.message")
      }
    ],
    [t]
  );
};
const WordBreak = styled.span`
  word-break: break-all;
`;
const WordBreakRenderer = (val) => /* @__PURE__ */ React.createElement(WordBreak, null, val);
const attributesRenderers = {
  alert: eventTypeAttribute,
  message: { renderCell: WordBreakRenderer }
};
const GeneralEventSideBar = ({ alertId, definitionId }) => {
  const { t } = useTranslation("events");
  const attributesList = useAttributesList();
  const { data: eventData, isLoading: isLoadingEvent } = useEventById(alertId);
  const resolvedDefinitionId = definitionId != null ? definitionId : eventData == null ? void 0 : eventData.event_definition_id;
  const { meta, isLoadingEventDefinition } = useEventsAdditionalData({
    eventData,
    definitionId: resolvedDefinitionId
  });
  const replaySearchContext = useMemo(
    () => ({
      alertId,
      definitionId: resolvedDefinitionId,
      type: (eventData == null ? void 0 : eventData.alert) ? "alert" : "event"
    }),
    [alertId, resolvedDefinitionId, eventData == null ? void 0 : eventData.alert]
  );
  if (alertId && isLoadingEvent || isLoadingEventDefinition) return /* @__PURE__ */ React.createElement(Spinner, null);
  return /* @__PURE__ */ React.createElement("div", null, alertId && /* @__PURE__ */ React.createElement(ExpandableSection, { title: t("alerts_replay.event_details") }, /* @__PURE__ */ React.createElement(
    EventDetailsDefinitionList,
    {
      event: eventData,
      meta,
      attributesList,
      attributesRenderers
    }
  )), resolvedDefinitionId && /* @__PURE__ */ React.createElement(ReplaySearchContext.Provider, { value: replaySearchContext }, /* @__PURE__ */ React.createElement(ExpandableSection, { title: t("alerts_replay.event_definition_details") }, /* @__PURE__ */ React.createElement(EventDefinitionInfoList, null))));
};
export default GeneralEventSideBar;
